<template>
  <div class="workspace workspace-grid">
    <div>
      <div class="static-element-header">3D View</div>
      <div v-if="hasWebGL()" class="static-element">
        <Solution3DView />
      </div>
      <div v-else class="static-element">
        Protein structure visualization is not supported!<br>
        Your browser or device may not support WebGL required to run the protein structure visualizer. Please ask your computer administrator for further assistance.
      </div>
    </div>
    <div>
      <JobDetail />
      <template v-if="getSolution != null">
        <div class="static-element-header">Selected Solution</div>
        <div class="static-element">
          <SolutionView />
        </div>
      </template>
      <div class="static-element-header">All Solutions</div>
      <div class="static-element">
        <SolutionsTable />
      </div>
    </div>
    <Tooltip />
  </div>
</template>

<script>
import Solution3DView from "../components/Solution3dView";
import SolutionsTable from "../components/SolutionsTable";
import SolutionView from "../components/SolutionView";
import Tooltip from "../components/Tooltip";
import { mapActions, mapGetters } from "vuex";
import JobDetail from "../components/JobDetail";
export default {
  components: {
    Solution3DView,
    SolutionsTable,
    SolutionView,
    Tooltip,
    JobDetail,
  },
  methods: {
    ...mapActions(["setToken"]),
    hasWebGL(){
      const canvas = document.createElement("canvas");
      return canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    }
  },
  computed: {
    ...mapGetters(["getSolution"]),
  },
  created() {
    this.setToken({ token: this.$route.params.jobId });
  },
};
</script>

<style>
</style>